import {styled} from "@mui/material/styles";

export const JobRunrProNotice = styled("div")`
    margin: -2rem 0 0.5rem 0;
    text-align: right
`;